import * as React from 'react';

const SmtpLogoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={65} height={55}>
    <path
      fill="#2D2756"
      d="m52.873 54.846-3.369-3.369 5.855-5.935H40.842v-4.813h14.517l-5.855-5.935 3.369-3.369 11.71 11.71-11.71 11.71ZM5.229 45.542c-1.323 0-2.456-.472-3.399-1.414-.942-.943-1.413-2.075-1.413-3.399V5.438c0-1.324.47-2.457 1.413-3.4.943-.942 2.076-1.413 3.4-1.413h44.916c1.323 0 2.456.471 3.399 1.414.942.942 1.413 2.075 1.413 3.398v18.609a18.42 18.42 0 0 0-2.406-.16c-.428 0-.829.013-1.203.04-.374.026-.775.066-1.203.12V9.207L27.366 25.33 5.23 9.288v31.441h28.153c-.053.428-.08.789-.08 1.083v1.103c0 .441.014.882.04 1.323.027.441.094.876.2 1.304H5.23ZM8.117 5.437l19.25 13.957 19.73-13.956H8.118Z"
    />
  </svg>
);

export default SmtpLogoIcon;
